<template>
  <div class="withdraw">
    <p>{{ $t('bank') }}</p>

    <md-input-item
      v-model="bankInfo.bankShortName"
      readonly
      is-title-latent
      :placeholder="$t('bank')"
      @focus="isBankSelectorShow = true"
    >
      <img
        v-if="bankInfo.bankNo"
        slot="left"
        class="icon_svg"
        :src="getIconByCode(bankInfo.bankNo)"
        alt="bank-icon"
      >
      <span
        slot="right"
        class="right_tig"
      >
        <svg-icon class="nav_svg" name="chevron-right" />
      </span>
    </md-input-item>

    <md-input-item
      v-model="account"
      :maxlength="20"
      clearable
      type="bankCard"
      is-title-latent
      :title="$t('transferAccountNumber')"
      :placeholder="$t('transferAccountNumber')"
      is-virtual-keyboard
      virtual-keyboard-vm="AccountKeyBoard"
    />

    <md-number-keyboard
      ref="AccountKeyBoard"
      type="professional"
      hide-dot
      :ok-text="$t('confirm')"
    />

    <!-- 金额键盘和输入框 -->
    <FinancialNumberKeyboard
      v-model="money"
      :error.sync="moneyErrorMessage"
    />

    <!-- 输入金额不符合规范、不是提现页面、卡里没有钱的不展示一下内容 -->
    <p v-if="!moneyErrorMessage" class="all-amount">
      Rp{{ formatAmount(allAmount) }} {{ $t('withdrawBalance') }}
      <span class="all" @click="allAmountHandle">{{ $t('all') }}</span>
    </p>

    <div class="transaction-button">
      <md-button
        type="primary"
        :inactive="submitInactive"
        @click="passwordVisiable = true"
      >
        {{ $t('withdrawTitle') }}
      </md-button>
    </div>

    <!-- 银行列表 -->
    <BankList
      v-model="isBankSelectorShow"
      :data="bankList"
      :bank-info="bankInfo"
      @selectBank="selectBank"
    />

    <!-- 支付键盘 -->
    <PasswordPopup
      v-model="passwordVisiable"
      :code.sync="password"
      :error.sync="passwordError"
      @finished="confirmMethod"
    />
    <!-- 控制支付loading -->
    <PayLoading :is-show="showLoading" />
  </div>
</template>

<script>
// 充值页面
import { Button, Toast, InputItem, NumberKeyboard } from 'mand-mobile'
import FinancialNumberKeyboard from '@/components/FinancialNumberKeyboard'
import PasswordPopup from '@/components/PasswordPopup'
import PayLoading from '@/components/PayLoading'
import { withdraw, limitAmount, walletAll } from '@/api/withdraw'
import { TRADE_TYPE, TRADE_TITLE, ERROR_REQ_CODE } from '@/constants'
import fenToYuan from '@/utils/fen-to-yuan'
import yuanToFen from '@/utils/yuan-to-fen'
import BankList from '@/components/BankList'
import { formatAmount } from '@/utils/format-amount'
import { getBankList } from '@/api/transfer'
import { getIconByCode } from '@flash/fin-logo'

export default {
  name: 'Withdraw',
  components: {
    FinancialNumberKeyboard,
    PasswordPopup,
    PayLoading,
    BankList,
    [InputItem.name]: InputItem,
    [NumberKeyboard.name]: NumberKeyboard,
    [Button.name]: Button
  },
  data () {
    return {
      TRADE_TYPE,
      getIconByCode,
      formatAmount,
      account: '',
      money: '', // 金额
      limitAmount: '', // 提现限额钱数
      allAmount: '', // 卡余额
      moneyErrorMessage: '', // 校验金额错误信息
      password: '', // 密码
      passwordVisiable: false, // 密码键盘
      passwordError: '', // 密码报错提示信息
      showLoading: false,
      isBankSelectorShow: false,
      bankInfo: {},
      bankList: [
        {
          id: '104002',
          bankNo: '104002',
          bankType: {
            code: 1,
            codeString: 'PHYSICAL_BANK',
            description: '实体银行'
          },
          bankName: 'Bank Negara Indonesia',
          bankShortName: 'BNI',
          bankEnAbbr: 'BNI',
          countryCode: {
            code: 360,
            codeString: 'IDN',
            description: 'Indonesia'
          }
        },
        {
          id: '104003',
          bankNo: '104003',
          bankType: {
            code: 1,
            codeString: 'PHYSICAL_BANK',
            description: '实体银行'
          },
          bankName: 'Bank Rakyat Indonesia',
          bankShortName: 'BRI',
          bankEnAbbr: 'BRI',
          countryCode: {
            code: 360,
            codeString: 'IDN',
            description: 'Indonesia'
          }
        }
      ]
    }
  },
  computed: {
    // 提交按钮是否禁用
    submitInactive () {
      return !(this.moneyErrorMessage === '' && this.account && this.bankInfo.bankNo && this.money)
    }
  },
  watch: {
    money (value) {
      // 金额不能小于10000
      if (+value < 10000 || value === '') {
        this.moneyErrorMessage = this.$t('more_amount') + ' Rp10.000'
      } else if (this.limitAmount && +value > this.limitAmount) { // 金额不能大于限额
        this.moneyErrorMessage = `${this.$t('less_amount_message')}${formatAmount(this.limitAmount)}`
      } else if (+value > +this.allAmount) { // 金额不能大于余额
        this.moneyErrorMessage = `${this.$t('less_amount_message')}${formatAmount(this.allAmount)}`
      } else {
        this.moneyErrorMessage = ''
      }
    }
  },
  created () {
    // this.getBankList()
    this.getLimitAmount() // 提现限额
    this.getAllAmount() // 卡余额
  },
  methods: {
    selectBank (option) {
      console.log(JSON.stringify(option))
      // 被选取卡的信息
      this.bankInfo = option
    },
    // 获取银行列表
    async getBankList () {
      this.bankList = await getBankList({ whetherSign: 0 })
    },
    async getLimitAmount () { // 提现限额
      const { limitAmount: amount } = await limitAmount({ payProductCode: TRADE_TITLE.Withdraw })
      if (amount) this.limitAmount = fenToYuan(amount)
    },
    async getAllAmount () { // 卡余额
      const data = await walletAll()
      this.allAmount = fenToYuan(data.balance)
    },
    // 被选取卡的信息
    getBankInfo (option) {
      this.bankInfo = option
    },
    allAmountHandle () { // 点击all
      this.money = this.allAmount
    },
    async confirmMethod (password) {
      this.passwordVisiable = false // 键盘隐藏

      try {
        this.showLoading = true // 支付loading弹起
        // 发起提现
        const { tradeNo } = await withdraw({
          password,
          payeeAccountNo: this.account,
          payeeBankNo: this.bankInfo.bankNo,
          amount: yuanToFen(this.money)
        })
        this.$router.replace({ name: 'WithdrawResult', query: { tradeNo } })
      } catch (e) {
        if (e.code === ERROR_REQ_CODE.passError) { // 密码错误
          this.passwordVisiable = true // 键盘显示
          this.passwordError = e.message
        } else {
          e.code && Toast.failed(e.message, 4000, null, document.body, true)
        }
      } finally {
        this.showLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.withdraw {
  height: 100%;
  padding: 0 40px;
}

.all-amount {
  margin-top: 10px;
  font-size: 24px;
  color: #b2b2b2;

  .all {
    color: #008eff;
    margin-left: 24px;
  }
}

.icon_svg {
  width: 64px;
  height: 64px;
  border-radius: 50%;
}
</style>
